import { Composition } from 'remotion';
import {
  RotateTransition,
  BounceTransition,
} from '../effects/Transitions';
import {
  TypewriterEffect,
  FlyInLetters,
  WaveText,
  ShakeText,
  ScaleText,
} from '../effects/TextAnimations';
import {
  NeonBorder,
  GlowingText,
  GradientText,
} from '../effects/GradientEffects';
import {
  GlitchEffect,
  ColorSplit,
  RGBShift,
} from '../effects/GlitchEffects';
import {
  TunnelEffect,
} from '../effects/DepthEffects';
import {
  HologramEffect,
} from '../effects/AdvancedVisualEffects';
import {
  MorphingShapes,
  BarChartAnimation,
  NumberCounter,
} from '../effects/SVGAndDataEffects';
import {
  LogoRevealGradient,
  LogoRevealScale,
  LogoRevealTypewriter,
  LogoRevealMask,
  LogoRevealSplit,
} from '../effects/PracticalEffects';
import {
  ImageFadeIn,
  ImageZoomIn,
  ImageSlideIn,
  ImageKenBurns,
  ImageBlurIn,
  ImageMaskReveal,
  ImageSplitSlide,
  ImageGridReveal,
  ImageDissolve,
  ImageColorSplit,
} from '../effects/ImageTransitions';
import {
  ImageCrossDissolve,
  ImageSlideOverlay,
  ImageBlinds,
  ImageGridTransition,
  ImageCircleExpand,
  ImageWipe,
  ImageRotateIn,
  ImagePageFlip,
  ImageZoomCross,
  ImageChannelSplit,
} from '../effects/ImageTransitionsAdvanced';

export const CoreEffectsCompositions = () => (
  <>
    {/* 🎬 过渡效果 */}
    <Composition
      id="RotateTransition"
      component={RotateTransition}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />
    <Composition
      id="BounceTransition"
      component={BounceTransition}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />

    {/* 🎬 文字动画效果 */}
    <Composition
      id="TypewriterEffect"
      component={TypewriterEffect}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ text: "Hello World" }}
    />
    <Composition
      id="FlyInLetters"
      component={FlyInLetters}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ text: "FLY IN" }}
    />
    <Composition
      id="WaveText"
      component={WaveText}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ text: "WAVE" }}
    />
    <Composition
      id="ShakeText"
      component={ShakeText}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ text: "SHAKE" }}
    />
    <Composition
      id="ScaleText"
      component={ScaleText}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ text: "SCALE" }}
    />

    {/* 🎬 渐变发光效果 */}
    <Composition
      id="NeonBorder"
      component={NeonBorder}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />
    <Composition
      id="GlowingText"
      component={GlowingText}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />
    <Composition
      id="GradientText"
      component={GradientText}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />

    {/* 🎬 故障特效 */}
    <Composition
      id="GlitchEffect"
      component={GlitchEffect}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />
    <Composition
      id="ColorSplit"
      component={ColorSplit}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />
    <Composition
      id="RGBShift"
      component={RGBShift}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />

    {/* 🎬 3D 深度效果 */}
    <Composition
      id="TunnelEffect"
      component={TunnelEffect}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />
    {/* 🎬 高级视觉效果 */}
    <Composition
      id="HologramEffect"
      component={HologramEffect}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
    />

    {/* 🎬 SVG 和数据可视化效果 */}
    <Composition
      id="MorphingShapes"
      component={MorphingShapes}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
    />
    <Composition
      id="BarChartAnimation"
      component={BarChartAnimation}
      durationInFrames={90}
      fps={30}
      width={1280}
      height={720}
    />
    <Composition
      id="NumberCounter"
      component={NumberCounter}
      durationInFrames={90}
      fps={30}
      width={1280}
      height={720}
    />
    {/* 🎬 实用效果 - Logo 揭示 */}
    <Composition
      id="LogoRevealGradient"
      component={LogoRevealGradient}
      durationInFrames={90}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ logoText: "LOGO", color1: "#4ecdc4", color2: "#ff6b6b" }}
    />
    <Composition
      id="LogoRevealScale"
      component={LogoRevealScale}
      durationInFrames={90}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ logoText: "LOGO", color: "#ffffff" }}
    />
    <Composition
      id="LogoRevealTypewriter"
      component={LogoRevealTypewriter}
      durationInFrames={90}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ logoText: "LOGO", color: "#4ecdc4" }}
    />
    <Composition
      id="LogoRevealMask"
      component={LogoRevealMask}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ logoText: "LOGO", color: "#ffffff" }}
    />
    <Composition
      id="LogoRevealSplit"
      component={LogoRevealSplit}
      durationInFrames={90}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ logoText: "LOGO", color: "#ffffff" }}
    />

    {/* 🎬 图片过渡效果 */}
    <Composition
      id="ImageFadeIn"
      component={ImageFadeIn}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=1", duration: 60 }}
    />
    <Composition
      id="ImageZoomIn"
      component={ImageZoomIn}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=2", duration: 60 }}
    />
    <Composition
      id="ImageSlideIn"
      component={ImageSlideIn}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=3", direction: "left", duration: 60 }}
    />
    <Composition
      id="ImageKenBurns"
      component={ImageKenBurns}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=4", zoomDirection: "in" }}
    />
    <Composition
      id="ImageBlurIn"
      component={ImageBlurIn}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=5", duration: 60 }}
    />
    <Composition
      id="ImageMaskReveal"
      component={ImageMaskReveal}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=6", shape: "circle" }}
    />
    <Composition
      id="ImageSplitSlide"
      component={ImageSplitSlide}
      durationInFrames={60}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=7" }}
    />
    <Composition
      id="ImageGridReveal"
      component={ImageGridReveal}
      durationInFrames={80}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{ imageUrl: "https://picsum.photos/1280/720?random=8", gridSize: 4 }}
    />
    <Composition
      id="ImageDissolve"
      component={ImageDissolve}
      durationInFrames={150}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        imageUrl: "https://picsum.photos/1280/720?random=9",
        title: "Dissolve",
        subtitle: "噪点溶解 · 电影级转场",
        caption: "FRAMEFUTURE · CINEMATIC",
        number: "09",
        cols: 48,
        rows: 27,
      }}
    />
    <Composition
      id="ImageColorSplit"
      component={ImageColorSplit}
      durationInFrames={150}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        imageUrl: "https://picsum.photos/1280/720?random=10",
        title: "CHROMATIC",
        subtitle: "RGB 色彩分离 · 故障艺术",
        caption: "FRAMEFUTURE · GLITCH LAB",
        number: "70",
      }}
    />

    {/* 🎬 双图过渡效果 */}
    <Composition
      id="ImageCrossDissolve"
      component={ImageCrossDissolve}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=11",
        image2Url: "https://picsum.photos/1280/720?random=12",
        transitionDuration: 30,
      }}
    />
    <Composition
      id="ImageSlideOverlay"
      component={ImageSlideOverlay}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=13",
        image2Url: "https://picsum.photos/1280/720?random=14",
        direction: "left",
      }}
    />
    <Composition
      id="ImageBlinds"
      component={ImageBlinds}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=15",
        image2Url: "https://picsum.photos/1280/720?random=16",
        blindsCount: 8,
        direction: "horizontal",
      }}
    />
    <Composition
      id="ImageGridTransition"
      component={ImageGridTransition}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=17",
        image2Url: "https://picsum.photos/1280/720?random=18",
        gridSize: 5,
      }}
    />
    <Composition
      id="ImageCircleExpand"
      component={ImageCircleExpand}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=19",
        image2Url: "https://picsum.photos/1280/720?random=20",
      }}
    />
    <Composition
      id="ImageWipe"
      component={ImageWipe}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=21",
        image2Url: "https://picsum.photos/1280/720?random=22",
        direction: "left",
      }}
    />
    <Composition
      id="ImageRotateIn"
      component={ImageRotateIn}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=23",
        image2Url: "https://picsum.photos/1280/720?random=24",
      }}
    />
    <Composition
      id="ImagePageFlip"
      component={ImagePageFlip}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=25",
        image2Url: "https://picsum.photos/1280/720?random=26",
      }}
    />
    <Composition
      id="ImageZoomCross"
      component={ImageZoomCross}
      durationInFrames={150}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url:
          "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1280&q=80",
        image2Url:
          "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1280&q=80",
        motionBlur: true,
        flash: true,
        vignette: true,
      }}
    />
    <Composition
      id="ImageChannelSplit"
      component={ImageChannelSplit}
      durationInFrames={120}
      fps={30}
      width={1280}
      height={720}
      defaultProps={{
        image1Url: "https://picsum.photos/1280/720?random=29",
        image2Url: "https://picsum.photos/1280/720?random=30",
      }}
    />
  </>
);
